"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkipValidationsIf = void 0;
const class_validator_1 = require("class-validator");
const compact_1 = __importDefault(require("lodash/compact"));
/**
 * Skip validations if conditions are passed
 * NOTE: Async conditions are not supported here
 */
function SkipValidationsIf(condition, options) {
    return (0, class_validator_1.ValidateIf)((object, value) => {
        const conditions = (0, compact_1.default)([].concat(condition));
        const allConditionsMet = conditions.every((conditionfn) => conditionfn(value, { object }));
        const shouldValidate = !allConditionsMet;
        return shouldValidate;
    }, options);
}
exports.SkipValidationsIf = SkipValidationsIf;
//# sourceMappingURL=SkipValidationsIf.js.map